import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";

import {
  addCustomer,
  GetCountry,
  GetCurrency,
  GetPayTerms,
} from "../../services/customerService";
import EnhancedPageTitle from "../../Component/EnhancedPageTitle";

const AddCustomer = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    customerName: "",
    primaryContact: "",
    countryId: "",
    currencyId: "",
    payTermsId: "",
    isActive: true,
  });

  const [countries, setCountries] = useState<any[]>([]);
  const [currencies, setCurrencies] = useState<any[]>([]);
  const [payTerms, setPayTerms] = useState<any[]>([]);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error",
  });
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const loadMasterData = async () => {
      try {

        const [countryRes, currencyRes, payTermsRes] = await Promise.all([

          GetCountry(),
          GetCurrency(),
          GetPayTerms(),
        ]);
        setCountries(countryRes);
        console.log("Country data:", countryRes);

        setCurrencies(currencyRes);
        setPayTerms(payTermsRes);
      } catch (err) {
        console.error("Error loading master data", err);
      }
    };

    loadMasterData();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: ["countryId", "currencyId", "payTermsId"].includes(name)
        ? Number(value)
        : value,
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSaveClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleReset = () => {
    setFormData({
      customerName: "",
      primaryContact: "",
      countryId: "",
      currencyId: "",
      payTermsId: "",
      isActive: true,
    });
  };

  const handleSubmit = async () => {
    setConfirmOpen(false);

    try {
      const payload = {
        customerName: formData.customerName,
        primaryContact: formData.primaryContact,
        countryId: formData.countryId,
        currencyId: formData.currencyId,
        payTermsId: formData.payTermsId,
        createdOn: new Date().toISOString(),
        createdBy: 0,
        modifiedOn: new Date().toISOString(),
        modifiedBy: 0,
        isDeleted: false,
        isActive: formData.isActive,
        customerId: 0,
      };

      await addCustomer(payload);

      setSnackbar({
        open: true,
        message: "Customer added successfully",
        severity: "success",
      });

      setShouldNavigate(true);
    } catch (error) {
      console.error("Error adding customer:", error);
      setSnackbar({
        open: true,
        message: "Error adding customer",
        severity: "error",
      });
      setShouldNavigate(false);
      
    setLoading(false); // hide loader
    }
  };
  <Backdrop
  sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={loading}
>
  <CircularProgress color="inherit" />
</Backdrop>


  return (
    <Box sx={{ bgcolor: "#F0F2F5", p: 3, minHeight: "100vh" }}>
      <EnhancedPageTitle
        title="Add Customer"
        button1Text="Back"
        button1Action={() => navigate("/Customers")}
      />

      <Card
        elevation={1}
        sx={{ bgcolor: "#fff", p: 4, maxWidth: "700px", mx: "auto" }}
      >
        <Typography variant="h6" mb={3}>
          New Customer
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Customer Name"
              name="customerName"
              value={formData.customerName}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Primary Contact"
              name="primaryContact"
              value={formData.primaryContact}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Country"
              name="countryId"
              value={formData.countryId}
              onChange={handleChange}
            >
              <MenuItem value="">--Select--</MenuItem>
              {countries.map((country) => (
                <MenuItem key={country.tableID} value={country.tableID}>
                  {country.tableName}
                </MenuItem>
              ))}
            </TextField>


          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Currency"
              name="currencyId"
              value={formData.currencyId}
              onChange={handleChange}
            >
              <MenuItem value="">--Select--</MenuItem>
              {currencies.map((currency) => (
                <MenuItem key={currency.tableID} value={currency.tableID}>
                  {currency.tableName}
                </MenuItem>
              ))}
            </TextField>

          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Payment Terms"
              name="payTermsId"
              value={formData.payTermsId}
              onChange={handleChange}
            >
              <MenuItem value="">--Select--</MenuItem>
              {payTerms.map((pt) => (
                <MenuItem key={pt.tableID} value={pt.tableID}>
                  {pt.tableName}
                </MenuItem>
              ))}
            </TextField>

          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isActive}
                  onChange={handleCheckboxChange}
                  name="isActive"
                />
              }
              label="Is Active"
            />
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="contained" color="primary" onClick={handleSaveClick}>
              Save
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleReset}>
              Reset
            </Button>
          </Grid>
        </Grid>
      </Card>

      <Dialog open={confirmOpen} onClose={handleConfirmClose}>
        <DialogTitle>Confirm Save</DialogTitle>
        <DialogContent>
          Are you sure you want to save this customer?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          setSnackbar((prev) => ({ ...prev, open: false }));
          if (shouldNavigate && snackbar.severity === "success") {
            navigate("/Customers");
          }
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddCustomer;
